import React from 'react'
import { Link } from 'react-router-dom'
const NLink: React.FC<any> = (props) => {
    const { children, ...rest } = props
    return <Link {...rest} style={{ verticalAlign: 'unset' }}>{ children }</Link>
}
export default NLink
